import { useEffect } from 'react';

function useHelpEvent(path: string, onMatch: () => void) {
  useEffect(() => {
    const onOpenHelp = () => {
      const currentPath = window.location.pathname;
      if (currentPath.startsWith(path)) {
        onMatch();
      }
    };

    window.addEventListener('openHelp', onOpenHelp);
    return () => {
      window.removeEventListener('openHelp', onOpenHelp);
    };
  }, [path, onMatch]);
}

export default useHelpEvent;
